<template>
  <SlideSidebarContainer>
    <template #title>
      <div class="d-flex align-items-center">
        <UserAvatar :user="user" class="mr-2"/>
        <span>bio de {{ user.name }}</span>
      </div>
    </template>

    <p v-html="user.bio" class="bio"></p>
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import UserAvatar from '@/components/user/UserAvatar'
  
  export default {
    components: {
      SlideSidebarContainer,
      UserAvatar,
    },

    props: {
      user: { type: Object, required: true }
    }
  }
</script>

<style scoped lang="scss">
  .bio {
    font-family: 'Poppins';
    font-size: 17px;
    line-height: 26px;
    letter-spacing: .5px;
  }
</style>